<div class="card shadow-sm rounded-3">
  <div class="card-body">
    <div class="d-flex justify-content-between align-items-center">
      <h4 class="fw-bold text-dark m-0 d-flex align-items-center">
        <i class="las la-money-check-alt me-2"></i> {{ 'MENU.PAYMENTS' | translate }}
      </h4>
      <button (click)="onAdd()" class="btn btn-primary btn-sm py-2">
        <i class="las la-plus me-1"></i> {{ 'ADD' | translate }} {{ 'PAYMENT.PAYMENT' | translate }}
      </button>
    </div>
    <p class="text-muted mt-2 mb-0">{{ 'APARTMENT.PAYMENTS_DESCRIPTION' | translate }}</p>
    <div class="mt-4">
      <p-table
        [hasList]="service.hasList"
        (add)="onAdd()"
        (delete)="onDelete($event)"
        (edit)="onEdit($event)"
        (onLazyLoad)="loadData($event)"
        (onPage)="pageChange($event)"
        (view)="onView($event)"
        [columns]="fields"
        [dataKey]="'id'"
        [first]="first"
        [globalSearch]="globalSearch"
        [hasActions]="false"
        [hasAdd]="false"
        [hasDelete]="false"
        [hasEdit]="false"
        [hasView]="false"
        [loading]="loading()"
        [rows]="rows"
        [selectionMode]="'single'"
        [title]="service.title"
        [totalRecords]="total"
        [value]="list"
        paginatorPosition="bottom"
        tableStyleClass="table table-hover custom-table"
      >
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="service.tableColumns.length">
              <p class="text-muted mb-0 text-center">
                <i class="las la-search-minus"></i>
                {{ 'RESIDENTS.NO_RECORDS' | translate }}
              </p>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
